import { apiRoutes } from '../../api-routes';
import { adminOnwheelApiUrl } from '../../constants';
import { publicHttpClient } from '../../util';

export type PartnerConfig = {
  name: string;
  logo?: PartnerLogo;
  marker?: AdsMarker;
  featured_banner?: PartnerBanner;
  banner?: PartnerBanner[];
  mapStyle?: string;
  show_order_price?: boolean;
  disabled_info_panel?: boolean;
};

export type PartnerBanner = {
  img_uri: string;
  href?: string;
  dimensions?: string;
  order?: number;
  isSponsored?: boolean;
};

export type PartnerLogo = {
  default: string;
  dark?: string;
  light?: string;
};

export type AdsMarker = {
  image: string;
  href?: string;
  theme?: 'light' | 'dark';
  image_size?: number;
};

export interface PartnerSettingCommonResponse {
  data: PartnerConfig;
}

export const getPartnerSettingCommonFn = async (
  partner: PartnerConfig['name']
) => {
  const response = await publicHttpClient.get<PartnerSettingCommonResponse>(
    adminOnwheelApiUrl + apiRoutes.onwheel.partner_setting_common,
    { params: { partner } }
  );
  if (response?.data?.data && Object.keys(response.data.data).length > 1) {
    return response.data.data;
  }

  return null;
};
